var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.data === null)?_c('placeholder',[_vm._v("\n        未上传合照\n    ")]):_c('img',{staticClass:"group-photo",attrs:{"src":_vm.src,"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }